import React, { useEffect, useRef } from 'react';
import { H4 } from './text';

// Blue Billywig channel IDs per team, keyed by StatsPerform contestantCode
const TEAM_VIDEO_CHANNELS: Record<string, number> = {
	HER: 1453, // Heracles Almelo
	ALM: 1258, // Almere City FC
	GRA: 1259, // De Graafschap
	DBO: 1260, // FC Den Bosch
	DOR: 1261, // FC Dordrecht
	EIN: 1262, // FC Eindhoven
	EMM: 1263, // FC Emmen
	HEL: 1264, // Helmond Sport
	JAJ: 1265, // Jong Ajax
	JAZ: 1266, // Jong AZ
	JUT: 1267, // Jong FC Utrecht
	JPS: 1268, // Jong PSV
	MVV: 1269, // MVV Maastricht
	RKC: 1270, // RKC Waalwijk
	RJC: 1271, // Roda JC Kerkrade
	VOL: 1454, // FC Volendam
	TOP: 1273, // TOP Oss
	VIT: 1274, // Vitesse
	VVV: 1275, // VVV-Venlo
	NAC: 1455, // NAC Breda
};

interface TeamVideoEmbedProps {
	contestantCode: string;
}

const TeamVideoEmbed: React.FC<TeamVideoEmbedProps> = ({ contestantCode }) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const channelId = TEAM_VIDEO_CHANNELS[contestantCode];

	useEffect(() => {
		const container = containerRef.current;
		if (!container || !channelId) return;

		const script = document.createElement('script');
		script.src = `https://ced.bbvms.com/ch/${channelId}.js`;
		script.async = true;
		container.appendChild(script);

		// Clear the script and any player markup it injected
		return () => {
			container.innerHTML = '';
		};
	}, [channelId]);

	if (!channelId) return null;

	return (
		<section>
			<div className="bbvms-container" ref={containerRef}></div>
		</section>
	);
};

export default TeamVideoEmbed;
